export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-TrainCitySelector',
            name: 'admin-yinzhilv-demo-TrainCitySelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-TrainCitySelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-TrainCitySelector`},
                ],
            },
        },
    ],
};
